import React from 'react'
import { FastField } from 'utils-next/forms'

import Select, { SelectProps } from './Select.component'

const SelectFormik = (props: SelectProps) => <FastField component={Select} {...props} />

export default SelectFormik
